import Vue from "vue";
import axios from "axios";

// import customSetting from "../../../public/config/customSetting.json";
Vue.prototype.apiUrl = self.customSetting.apiUrl;
const baseApi = self.customSetting.apiUrl;
// const controller = customSetting.DocSearchController;
const getFrontPage = self.customSetting.getFrontPage;
//const postFrontPage = self.customSetting.postFrontPage;

export default {
  checkVendorRole: (data) => {
    return axios.get(`${baseApi}/${getFrontPage}/checkVendorRole`, data);
  },
  GetResultsList: () => {
    return axios.get(`${baseApi}/${getFrontPage}/GetResults`);
  },
  //getContactList: () => {
  //  return axios.get(`${baseApi}/${getFrontPage}/ContactList`);
  //},
  //getProjectByINX: () => {
  //  return axios.get(`${baseApi}/${getFrontPage}/QryProjectByINX`);
  //},
  //getDailyByINX: () => {
  //  return axios.get(`${baseApi}/${getFrontPage}/QryDailyByINX`);
  //},
};
